<template>
	<div class="WastageCount">
		<!-- <el-button
			icon="el-icon-arrow-left"
			type="warning"
			style="width:auto; margin:10px;"
			size="mini"
			@click="$router.go(-1)"
		>
			Previous Page
		</el-button> -->
		<!-- <div class="table-sns">
      <h3>
      </h3>
      <a
        class="cursor-pointer"
      >
        Export Wastage Count
      </a>
    </div> -->
		<el-row :gutter="30" class="p-4">
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" class="mt-4">
				<div
					class="text-xs flex justify-center items-center text-white"
					style="background: #e29d5a; height: 40px"
				>
					{{ todaysDate }}
				</div>
			</el-col>
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" class="mt-4">
				<div class="Location">
					<el-select
						v-model="selectedOutletId"
						filterable
						style="width: 100%;height: 40px; margin: 0px;"
						placeholder="Select Outlet"
						@change="getStockCount"
					>
						<el-option
							v-for="(outlet, outletIndex) in outlets"
							:key="outletIndex"
							:value="outlet.id"
							:label="outlet.name"
						/>
					</el-select>
				</div>
			</el-col>
		</el-row>
		<div v-if="stockCount.length">
			<div class="table-heading">
				Upload Wastage Count
			</div>
			<div class="m-4">
				<simplebar class="simplebar">
					<table class="tableMain">
						<thead class="tableHeader">
							<tr>
								<th colspan="1" width="10%">
									Item
								</th>
								<th colspan="2" class="main-heading-spacing">
									<p class="main-heading-border-bottom">
										System Count
									</p>
								</th>
								<th colspan="2" class="main-heading-spacing">
									<p class="main-heading-border-bottom">
										Wastage Quantity
									</p>
								</th>
								<th class="main-heading-spacing">
									Reason
								</th>
								<th width="5%">
									Save
								</th>
							</tr>
							<tr>
								<th colspan="1">
									&nbsp;
								</th>
								<th colspan="1">
									Pack Qty
								</th>
								<th colspan="1">
									Loose Qty
								</th>
								<th colspan="1">
									Pack Qty
								</th>
								<th colspan="1">
									Loose Qty
								</th>
								<th colspan="1">
									&nbsp;
								</th>
								<th colspan="1">
									&nbsp;
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in stockCount" :key="index">
								<td class="capitalize">
									<div style="min-width: 40px;">
										{{ item.article_info.name }}
									</div>
								</td>
								<td>
									{{ item.quantity }}
								</td>
								<td>
									{{ item.loose_quantity }}
								</td>
								<td class="number-input" style="width:200px;">
									<el-input-number
										v-model="item.updatedQuantity"
										style="width:200px;"
										:min="0"
										:max="item.quantity"
									/>
								</td>
								<!-- <td class="">
								<el-select v-model="actualCountPack" placeholder="Pack">
									<el-option
										v-for="item in 5"
										:key="item"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td>
							<td class="custom-elementUi-css">
								<el-input-number v-model="num" size="mini" />
							</td> -->
								<!-- <td class="">
								<el-select v-model="actualCountLoose" placeholder="Loose">
									<el-option
										v-for="item in 5"
										:key="item"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td> -->
								<td class="number-input" style="width:200px;">
									<el-input-number
										v-model="item.updatedLooseQuantity"
										style="width:200px;"
										:min="0"
										:max="item.loose_quantity"
									/>
								</td>
								<td class="">
									<el-select
										v-model="item.reason"
										placeholder="Reason"
										style="width:60%;"
									>
										<!-- <el-option v-for="(item,index) in reason-drop:key="index"
									:label="item" :value="item" /> -->
										<el-option
											v-for="(reasons, reasonindex) in reasonDrop"
											:key="reasonindex"
											:label="reasons"
											:value="reasons"
										></el-option>
									</el-select>
								</td>
								<td>
									<BaseButton
										class="mr-8 w-full"
										buttonclass="btn py-1.5 px-4 text-sm"
										@click="saveWastageCount(item)"
									>
										Save
									</BaseButton>
								</td>
							</tr>
						</tbody>
					</table>
				</simplebar>
				<div class=" flex justify-end items-center p-2 pr-4">
					<!-- <BaseButton
					class="mr-8"
					buttonclass="btn py-1.5 px-4 text-sm"
					@click="saveWastageCount"
				>
					Save Count
				</BaseButton> -->
					<div>
						<!-- <el-pagination
						background
						:page-sizes="[5, 10, 15]"
						layout="sizes, prev, pager, next"
					/> -->
						<el-pagination
							background
							:current-page.sync="pageInfo.currentPage"
							:page-sizes="[5, 10, 15]"
							:page-size.sync="pageInfo.pageSize"
							layout="sizes, prev, pager, next"
							:total="pageInfo.totalCount"
							@size-change="handlePageInfoChange"
							@current-change="handlePageInfoChange"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import InventoryService from "../../../../services/inventoryService";
import moment from "moment";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import CommonService from "../../../../services/commonService.js";
import { async } from "q";
import { CommonMixin } from "../../../../../mixins/common.mixin";
export default {
	name: "WastageCount",
	components: {
		simplebar
	},
	mixins: [CommonMixin],
	data() {
		return {
			reason: "",
			selectedOutletId: "",
			outlets: {},
			// systemCountPack: "",
			// systemCountPackQty: "",
			// systemCountLoose: "",
			// systemCountLooseQty: "",
			// actualCountPack: "",
			// actualCountPackQty: "",
			// actualCountLoose: "",
			// actualCountLooseQty: "",
			// varianceCountPack: "",
			// varianceCountPackQty: "",
			// varianceCountLoose: "",
			// varianceCountLooseQty: "",
			reasonDrop: [
				"Expired",
				"Bottle Broken",
				"Customer Return",
				"Damaged Product"
			],
			pageInfo: {
				currentPage: 1,
				totalCount: 0,
				pageSize: 10,
				search: ""
			},
			expiryDate: "",
			expiryDateQty: "",
			num: 2,
			wnumastageCount: [],
			stockCount: []
		};
	},
	computed: {
		todaysDate() {
			return moment().format("YYYY-MM-DD");
		}
	},
	created() {
		this.getOutlets({ get_all: true });
	},
	methods: {
		paginate() {
			return async pageInfo => {
				this.stockCount = await this.getStockCount(
					this.selectedOutletId,
					this.todaysDate,
					pageInfo
				).then(data => data.results);
			};
		},
		getOutlets(args) {
			CommonService.getOutlets(args).then(response => {
				if (response.status == 200) {
					this.outlets = JSON.parse(response.data);
				}
			});
		},
		getStockCount(outletId, date, pageInfo) {
			InventoryService.getStockCount({
				outletId: this.selectedOutletId,
				date: this.todaysDate,
				pageInfo: this.pageInfo
			}).then(response => {
				if (response.status == 200) {
					let stockCount = JSON.parse(response.data);
					this.stockCount = stockCount.results;
					this.pageInfo.totalCount = stockCount.count;
					console.log("this.stockCount", stockCount);
					if (!this.stockCount.length) {
						this.$notify.warning({
							title: "Warning",
							message: "No Data Found !"
						});
					}
				}
			});
		},
		saveWastageCount(item) {
			console.log("item", item);
			InventoryService.saveWastageCount({
				outletId: this.selectedOutletId,
				date: this.todaysDate,
				params: {
					batch: item.id,
					article: item.article,
					quantity: item.updatedQuantity || item.quantity,
					loose_quantity: item.updatedLooseQuantity || item.loose_quantity,
					reason: "other" // backend needs to update
					// batch: stock.id,
					// old_loose_quantity: stock.loose_quantity,
					// quantity: stock.updatedQuantity || stock.quantity,
					// loose_quantity:
					// 	stock.updatedLooseQuantity || stock.loose_quantity,
					// reason: stock.reason
				}
			})
				.then(response => {
					console.log("response in saveStockCount", response);
					if (response.status === 200) {
						this.$notify.success({
							title: "Success",
							message: "Success"
						});
					}
				})
				.catch(err => {
					console.log(err);
					console.log(
						"JSON.parse(err.response.data)",
						JSON.parse(err.response.data)
					);
					if (err.response.status !== 200) {
						this.$notify.error({
							title: "Fail",
							message: JSON.parse(err.response.data).message
						});
					}
				});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./WastageCount.scss";
.tableHeader {
	background: #f2f2f2;
	text-transform: uppercase;
	color: #707070 !important;
	th {
		padding: 12px !important;
		font: Bold 13px/13px "Avenir", Helvetica, Arial, sans-serif !important;
		letter-spacing: 0px;
		color: #707070;
		// border-bottom: 2px solid #999;
	}
}
</style>

<style>
.WastageCount .el-select .el-input__inner {
	height: 30px;
	font-size: 12px;
	/* width: 55px; */
	margin: 3px;
}
.WastageCount .Location .el-select .el-input__inner {
	height: 40px;
	font-size: 12px;
	/* width: 55px; */
	margin: 0;
}
.WastageCount .alignCenter .el-select .el-input__inner {
	height: 40px;
	font-size: 12px;
	/* width: 55px; */
	margin: 0;
}
.el-pagination {
	margin-bottom: 10px;
}
.WastageCount .number-input .el-input__inner {
	border: none;
}
.WastageCount .number-input .el-input-number__decrease,
.el-input-number__increase {
	width: 60px;
}
.WastageCount .el-input-number__decrease {
	background: #dddddd 0% 0% no-repeat padding-box;
	/* background: #ff5353 0% 0% no-repeat padding-box; */
	border: 1px solid #f1f9ff;
	border-radius: 5px;
	/* color: white; */
	font-size: 18px;
	font-weight: bold;
}
.WastageCount .el-input-number__increase {
	/* color: white; */
	/* background: #25b57e 0% 0% no-repeat padding-box; */
	background: #dddddd 0% 0% no-repeat padding-box;
	border: 1px solid #f1f9ff;
	border-radius: 5px;
	font-size: 18px;
	font-weight: bold;
}
.el-select-dropdown__item {
	text-transform: capitalize;
}
</style>
